
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus, Image, Puzzle, File } from "lucide-react";

const DashboardActions = () => {
  return (
    <div className="flex flex-col sm:flex-row gap-2">
      <Link to="/admin/image-repository">
        <Button variant="outline" className="flex items-center gap-2 w-full sm:w-auto">
          <Image size={16} /> Image Repository
        </Button>
      </Link>
      <Link to="/admin/tools">
        <Button variant="outline" className="flex items-center gap-2 w-full sm:w-auto">
          <Puzzle size={16} /> Manage Tools
        </Button>
      </Link>
      <Link to="/admin/root-file-manager">
        <Button variant="outline" className="flex items-center gap-2 w-full sm:w-auto">
          <File size={16} /> Root Files
        </Button>
      </Link>
      <Link to="/admin/new-post">
        <Button className="bg-elfGreen hover:bg-elfGreen-dark w-full sm:w-auto">
          <Plus size={16} className="mr-2" /> New Blog Post
        </Button>
      </Link>
    </div>
  );
};

export default DashboardActions;
